import React, { useRef, useState } from 'react';
import { useInView } from '../hooks/useInView';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {

  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef<HTMLFormElement>(null);
  const { ref, inView } = useInView({ threshold: 0.1 });

  const sendEmail = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        from_name: name,
        from_email: email,
        message: message,
        to_email: 'duttameghali401@gmail.com'
      };

      console.log('Sending email with params:', templateParams);
      
      emailjs.send(
        'service_wr1s56q',
        'template_nkwpdei',
        templateParams, 
        '2qIY0nYLaiz3xxj_v'
      ).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message sent successfully!');
          setName('');
          setEmail('');
          setMessage('');
        },
        (error) => {
          console.log('FAILED...', error);
          alert('Failed to send message. Please try again or email directly.');
        },
      );
    }
  };

  return (
    <div ref={ref} className={`section-fade ${inView ? 'in-view' : ''}`} id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Coding Profiles & Achievements</h1>
          <div className="achievements-section">
            <ul>
              <li>🏆 <strong>LeetCode:</strong> Solved 400+ DSA problems</li>
              <li>🥇 <strong>Google Solution Challenge 2025:</strong> Finalist — Top 105 Teams</li>
              <li>🥈 <strong>EY Techathon 2025:</strong> National Finalist</li>
              <li>🥉 <strong>Hack Overflow 9.0:</strong> Finalist — NIT Durgapur</li>
              <li>🚀 Participated in 4+ National & International Hackathons</li>
              <li>💻 Active open-source contributor in AI and Blockchain projects</li>
            </ul>
          </div>
          
          <h1>Contact Me</h1>
          <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
          <div className="contact-info">
            <p>📧 <a href="mailto:duttameghali401@gmail.com">duttameghali401@gmail.com</a></p>
            <p>📞 <a href="tel:+918013056758">+91-8013056758</a></p>
          </div>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
            <div className='form-flex'>
              <TextField
                required
                id="outlined-required"
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setName(e.target.value);
                }}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
              />
              <TextField
                required
                id="outlined-required"
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? "Please enter your email or phone number" : ""}
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setMessage(e.target.value);
              }}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;